module.exports = __webpack_public_path__ + "components/weather-icon/static/daylightsnow-b9506a6dd61b2941e8051c54415a5dd5.webp";